export default "__VITE_ASSET__7e5620cb__"